/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import React from 'react';
import { AppConfiguration } from '../lib/type';
import { Scenario } from '../data/constants';

import Intro from './Intro/Intro';
import Questions from './Questions';
import Success from './Success/Success';
import Results from './Results/Results';
import './RAIAssessment.scss';

export interface RAIAssessmentProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}
// Defining a type for selectedOption context element

export const layoutContext = createContext({
  currentScenario: '',
  setCurrentScenario: (type: Scenario) => {},
  selectedItems: {},
  setSelectedItems: (items: object) => {},
  questionId: 'q1',
  setQuestionId: (question: string) => {},
  answers: {},
  setAnswers: (answers: object) => {},
  selectedOption: {
    optionId: '',
    nextStep: '',
  },
  setSelectedOption: (items: { optionId: string; nextStep: string }) => {},
});

const RAIAssessment = ({ configuration }: RAIAssessmentProps): ReactElement => {
  const [currentScenario, setCurrentScenario] = useState(Scenario.introduction);
  const [questionId, setQuestionId] = useState('q1');
  const [selectedItems, setSelectedItems] = useState({});
  const [answers, setAnswers] = useState({});
  const [selectedOption, setSelectedOption] = useState({
    optionId: '',
    nextStep: '',
  });

  const handleScenario = () => {
    switch (currentScenario) {
      case 'introduction':
        return <Intro contents={configuration.introduction} />;
      case 'questions':
        return <Questions contents={configuration.questions} />;
      case 'success':
        return <Success contents={configuration.success} />;
      case 'results':
        return (
          <Results
            contents={{
              results: configuration.results,
              questions: configuration.questions,
            }}
          />
        );
      default:
        return <Intro contents={configuration.introduction} />;
    }
  };

  return (
    <layoutContext.Provider
      value={{
        currentScenario,
        setCurrentScenario,
        selectedItems,
        setSelectedItems,
        questionId,
        setQuestionId,
        answers,
        setAnswers,
        selectedOption,
        setSelectedOption,
      }}
    >
      <div className="rai-assessment widget-styles">{handleScenario()}</div>
    </layoutContext.Provider>
  );
};

export default RAIAssessment;
